/**
 * etc 业务工具
 */
// import ETC from '@/config/etc.config'

import ETC from '@/config/etc.config'
let appChannel = ''
class ETCUtil {
  /**
   * 获取用户登录的token
   */
  static getToken() {
    let expireTime = localStorage.getItem(
      ETC.LOCAL_STORAGE_KEY.TOKEN_EXPIRE_TIME
    )
    if (expireTime < Date.now()) {
      return false
    }
    return localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN)
  }
  /**
   * 设置用户登录的Token
   * @param {*} token
   */
  static setToken(token) {
    if (!token) throw new Error('token is blank')
    let expireTime = Date.now() + 5 * 24 * 60 * 60 * 1000
    localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, token)
    localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN_EXPIRE_TIME, expireTime)
    return expireTime
  }
  static clearToken() {
    localStorage.removeItem(ETC.LOCAL_STORAGE_KEY.TOKEN)
  }
  // h5现有三种办理方式
  // 招行zhaohang =》 传参数进入 channel uid 提交地址 签约招行免密 旧版提交资料前置页面 办卡进度
  // 平安好车主 pnhcz =》 传参数进入 channel  uid  issuerId=2 定制化页面样式   提交地址  选择银行（中行） 提交资料（uploadCredentials） 办卡进度
  // 剩余全部为H5 2.0 办理方式  区别在于小程序端签约不同的免密
  // static goApplyPage(toPage, status, router, type, queryParams = {}, stepList) {
  static goApplyPage(toPage = 'goodsAddress', step_list = {}, router, queryParams = {}, hasCard = 0, type = '') {
    // 0:无步骤 1:定制卡片第一步manuApply(1,) 2:上传身份证页uploadIDCard(2,1) 3:免密页paySuccess 4:绑定成功页 5:办卡进度 6:个人中心
    console.log('arguments', [...arguments])
    appChannel = appChannel || localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)
    let name = toPage
    // 有卡用户跳转
    if (hasCard) {
      switch (appChannel) {
        // case 'pahcz':
        //   name = 'throughRec'
        //   break;
        default:
          name = 'bindSuccess'
          break;
      }
      return router.push({ name })
    } else if (step_list.has_done) {
      // localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
      // 提交地址为最后一步
      console.log('step_list', step_list)
      if (~step_list.has_done.indexOf('SubmitReviewOrder')) {
        name = 'applyProgress'
      } else {
        switch (appChannel) {
          case 'zhaohang':
            // 招行支付为伪支付（仅调用接口） 支付签约为同一步骤
            if (~step_list.has_done.indexOf('Pay') && ~step_list.has_done.indexOf('SignEntrust')) name = 'orderInfo'
            break;
          // case 'pahcz':
          //   if (~step_list.has_done.indexOf('Pay')) name = 'uploadCredentials'
          //   break;
          default:
            if (~step_list.has_done.indexOf('Pay')) name = 'applyProgress'
            break;
        }
      }
    }
    // if (name === 'applyProgress') {
    //   router.replace({ name, params: queryParams })
    // }
    if (name === 'goodsAddress') {
      if (type === 'click') router.push({ name, params: queryParams })
    } else {
      router.push({ name, params: queryParams })
    }

    // if (name === 'paySuccess') {
    //   router.push({ name: 'paySuccess', params: queryParams })
    // } else {
    //   router.push({ name, params: queryParams })
    // }

    // 无卡用户

    // router.push({ name })
    // switch (status) {
    //   case 0:
    //     if (type === 'click') {
    //       router.push({ name })
    //     }
    //     return
    //   case 1: // 设备定制页
    //     name = 'orderInfo'
    //     router.push({ name })
    //     return
    //   case 3:
    //     name = 'paySuccess'
    //     break
    //   case 4:
    //     name = 'bindSuccess'
    //     break
    //   case 5:
    //     name = 'applyProgress'
    //     break
    //   case 6:
    //     name = 'center'
    //     break
    //   case 8:
    //     name = 'throughRec'
    //     break
    //   // todo 招行免密
    //   // case 7: // 招行免密
    //   //   name = 'bindMM'
    //   //   break
    //   default:
    //     if (type === 'click') router.push({ name })
    //     return
    // }
    // if (name === 'paySuccess') {
    //   router.push({ name: 'paySuccess', params: queryParams })
    // } else {
    //   router.push({ name, params: queryParams })
    // }
    // else if (name === 'orderInfo' || name === 'payDeposit' || name === 'applyProgress') {
    //   router.push({name})
    // } else {
    //   router.replace({name, params: {replace: true}})
    // }
  }
  //  0:无步骤 1:定制卡片第一步manuApply(1,) 2:上传身份证页uploadIDCard(2,1) 3:免密页paySuccess 4:绑定成功页 5:办卡进度 6:个人中心
  static getApplyStatus(step_list, appChannel, isBind, prepayStatus) {
    // if (status === 99) return 0
    if (appChannel === 'tencent') {
      return 3
    }
    if (step_list.has_done && ~step_list.has_done.indexOf('SubmitReviewOrder')) {
      return 5 // applyProgress
    }
    if (appChannel === 'zhaohang') {
      // 3：招行签订免密状态，招行签完免密之后去设备定制页
      return 1
      // todo 招行保证金
      // if (status === 3) { // 3：招行签订免密状态，招行签完免密之后去支付押金
      // // if (status === 3) { // 3：招行签订免密状态，招行签完免密之后去设备定制页
      // //   return 1
      //   // 签约
      //   if (prepayStatus === 2) return 7
      //   // 支付
      //   if (prepayStatus === 3) return 1
      // } else {
      //   return 5 // applyProgress
      // }
    }
    if (isBind) {
      // 绑定小程序
      if (appChannel === 'zhaohang') return 5
      return 4
    }
    // return 3 // 已上传图片资料 已免密
    return 5
  }
  // 用户资料缓存新旧兼容
  static carInfoDataFormat(oridata = {}) {
    // 新流程接口的信息处理一下，改成旧流程的格式
    const { draft_id_card, draft_vehicle } = oridata
    // 身份证信息
    const id_card_info = draft_id_card && draft_id_card[1]
    // 港澳回乡证
    // const hk_mc_pass_info = draft_id_card && draft_id_card[2]
    // 台胞证
    // const taiwan_pass_info = draft_id_card && draft_id_card[3]
    // 行驶证
    const vehicle_info = draft_vehicle
    // 营业执照
    // const biz_licence_info = draft_biz_licence
    // 上传状态
    const infoStatus = {
      idcard: id_card_info && id_card_info.auto_validated ? 1 : 0,
      vehicle_license: vehicle_info && vehicle_info.auto_validated ? 1 : 0
      // biz_license: biz_licence_info && biz_licence_info.auto_validated ? 1 : 0,
      // hm_pass: hk_mc_pass_info && hk_mc_pass_info.auto_validated ? 1 : 0,
      // tw_pass: taiwan_pass_info && taiwan_pass_info.auto_validated ? 1 : 0,
    }
    // 恶心的数据格式改造过程
    // 有 ocr_record_sn 代表 orc 识别成功了
    const ocrSuccess = {
      // biz_license: biz_licence_info && (biz_licence_info.ocr_record_sn || biz_licence_info.auto_validated) ? 1 : 0,
      // hk_mc_pass_front: hk_mc_pass_info && (hk_mc_pass_info.front_ocr_record_sn || hk_mc_pass_info.auto_validated) ? 1 : 0,
      idcard_back: id_card_info && (id_card_info.back_ocr_record_sn || id_card_info.auto_validated) ? 1 : 0,
      idcard_front: id_card_info && (id_card_info.front_ocr_record_sn || id_card_info.auto_validated) ? 1 : 0,
      // taiwan_pass_front: taiwan_pass_info && (taiwan_pass_info.front_ocr_record_sn || taiwan_pass_info.auto_validated) ? 1 : 0,
      vehicle_back: vehicle_info && (vehicle_info.back_ocr_record_sn || vehicle_info.auto_validated) ? 1 : 0,
      vehicle_front: vehicle_info && (vehicle_info.front_ocr_record_sn || vehicle_info.auto_validated) ? 1 : 0
    }
    const oldInfo = {
      img_url: {
        // biz_license: {
        //   biz_license: biz_licence_info ? biz_licence_info.img_url : ''
        // },
        // hm_pass: {
        //   hk_mc_pass_front: hk_mc_pass_info ? hk_mc_pass_info.front_img_url : ''
        // },
        idCard: {
          idcard_back: id_card_info ? id_card_info.back_img_url : '',
          idcard_front: id_card_info ? id_card_info.front_img_url : '',
          idcard_hold: id_card_info ? id_card_info.hold_img_url : ''
        },
        license: {
          vehicle_back: vehicle_info ? vehicle_info.back_img_url : '',
          vehicle_car: vehicle_info ? vehicle_info.car_img_url : '',
          vehicle_front: vehicle_info ? vehicle_info.front_img_url : ''
        }
        // tw_pass: {
        //   taiwan_pass_front: taiwan_pass_info ? taiwan_pass_info.front_img_url : ''
        // }
      },
      ocr_result: {
        // biz_license: ocrSuccess.biz_license ? biz_licence_info : null,
        // hk_mc_pass_front: ocrSuccess.hk_mc_pass_front ? hk_mc_pass_info : null,
        idcard_back: ocrSuccess.idcard_back ? id_card_info : null,
        idcard_front: ocrSuccess.idcard_front ? id_card_info : null,
        // taiwan_pass_front: ocrSuccess.taiwan_pass_front ? taiwan_pass_info : null,
        vehicle_back: ocrSuccess.vehicle_back ? vehicle_info : null,
        vehicle_front: ocrSuccess.vehicle_front ? vehicle_info : null
      },
      draft_sn: {
        // biz_license: biz_licence_info && biz_licence_info.draft_sn,
        // hm_pass: hk_mc_pass_info && hk_mc_pass_info.draft_sn,
        idCard: id_card_info && id_card_info.draft_sn,
        license: vehicle_info && vehicle_info.draft_sn
        // tw_pass: taiwan_pass_info && taiwan_pass_info.draft_sn,
      },
      ocr_success: ocrSuccess,
      validate_result: infoStatus
    }
    console.log('transform 2 oldInfo----', oldInfo)
    return { ...oridata, ...oldInfo }
  }
}

export default ETCUtil
